import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BackendMockConfig, BackendMocksService } from '../tokens/backend-mocks.token';
import { API_PATHS } from '../config/api-paths';

/**
 * REST-only implementation of `BackendMocksService`.
 *
 * Calls GET / PUT /services/embedded/api/master-admin/mock-providers via HttpClient.
 * Rule 07 / Rule 10 — no mock fallback. Playwright tests intercept via `page.route()`.
 *
 * Authority required: ROLE_MASTER_ADMIN (enforced server-side and by roleGuard on the route).
 */
@Injectable()
export class BackendMocksRestService implements BackendMocksService {
  private readonly http = inject(HttpClient);

  get(): Observable<BackendMockConfig> {
    return this.http.get<BackendMockConfig>(API_PATHS.BACKEND_MOCKS);
  }

  update(config: BackendMockConfig): Observable<BackendMockConfig> {
    return this.http.put<BackendMockConfig>(API_PATHS.BACKEND_MOCKS, config);
  }
}
